import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { pricingData } from "./comon/data";

const Pricing = () => {
    return (
        <React.Fragment>
            <section className="section bg-light" id="price">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={7}>
                            <div className="text-center">
                                <h4 className="title-heading text-uppercase">Our Pricing</h4>
                                <p className="title-desc text-muted mt-3">Tools are beyond the one-click install, async tech merges with ultimate flexibility experiences that have meaning and add a value.</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        {
                            (pricingData || [])?.map((price:any, index: number) => (
                                <Col lg={4} key={index}>
                                    <div className={`price mt-4 p-5 ${index === pricingData.length - 2 ? "bg-white" : ""}`}>
                                        <div className="item text-center">
                                            <div className="type pb-3">
                                                <h4>{price.type}</h4>
                                            </div>
                                            <div className="value">
                                                <h3>{price.value}<span>99$</span></h3>
                                                <span className={`${index === pricingData.length - 2 ? "per" : "per text-muted"}`}> Per Month</span>
                                            </div>
                                            <div className="feature">
                                                <ul className={`${index === pricingData.length - 2 ? "list-unstyled" : "list-unstyled text-muted"}`}>
                                                    <li>Bandwidth: {price.bandwidth}</li>
                                                    <li>Onlinespace: {price.onlinespace}</li>
                                                    <li>Support: No</li>
                                                    <li>Domain: {price.domain}</li>
                                                    <li>{price.prMonth} Projects per month</li>
                                                    <li>{price.hidden}</li>
                                                </ul>
                                            </div>
                                            <div>
                                                <a href="#!" className="btn btn-custom">Order Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        }
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Pricing;